module.exports = __webpack_public_path__ + "static/media/react.b0944aec.png";